export const ARROWS = [
  {
    class: 'year-prev',
    content: '«',
    left: 8,
    action: (d: Date) => d.setFullYear(d.getFullYear() - 1),
  },
  {
    class: 'month-prev',
    content: '‹',
    left: 36,
    action: (d: Date) => d.setMonth(d.getMonth() - 1),
  },
  {
    class: 'month-next',
    content: '›',
    right: 36,
    action: (d: Date) => d.setMonth(d.getMonth() + 1),
  },
  {
    class: 'year-next',
    content: '»',
    right: 8,
    action: (d: Date) => d.setFullYear(d.getFullYear() + 1),
  },
]

export const injectArrows = (container: Element) => {
  if (container.querySelector('.arrow-container')) return

  const arrowContainer = document.createElement('div')
  arrowContainer.className = 'arrow-container'
  Object.assign(arrowContainer.style, {
    position: 'absolute',
    inset: '0',
    pointerEvents: 'none',
    zIndex: '14',
  })

  ARROWS.forEach(({ class: className, content, left, right }) => {
    const arrow = document.createElement('div')
    arrow.className = `arrow ${className}`
    arrow.textContent = content
    Object.assign(arrow.style, {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      justifyContent: 'center',
      borderRadius: '3px',
      cursor: 'pointer',
      pointerEvents: 'auto',
      fontSize: '28px',
      ...(left !== undefined && { left: `${left}px` }),
      ...(right !== undefined && { right: `${right}px` }),
    })
    arrowContainer.appendChild(arrow)
  })

  container.appendChild(arrowContainer)
}
